/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_DASHBOARD_ATTENDANCE,
  LOAD_BIRTHDAY_LIST,
  LOAD_DASHBOARD_CHECKINOUT,
  LOAD_HOLIDAY_LIST,
  LOAD_YEARLY_LEAVE,
  LOAD_DAILY_PERCENTAGE_LIST,
  LOAD_WEEKLY_PERCENTAGE_LIST,
  LOAD_MONTHLY_PERCENTAGE_LIST,
  LOAD_EMPLOYEE_STATUS,
  LOAD_ATTENDANCE_OVERVIEW_TODAY,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH,
  LOAD_DEPARTMENT,
  LOAD_ATTENDANCE_OVERVIEW,
  LOAD_LATE,
  LOAD_EMPLOYEE_TYPE
} from "./constants";

import {
  loadBirthdayList,
  loadBirthdayListSuccess,
  loadBirthdayListError,
  loadDashboardAttendance,
  loadDashboardAttendanceSuccess,
  loadDashboardAttendanceError,
  loadDashboardCheckinOut,
  loadDashboardCheckinOutSuccess,
  loadDashboardCheckinOutError,
  loadHolidayList,
  loadHolidayListSuccess,
  loadHolidayListError,
  loadYearlyLeave,
  loadYearlyLeaveSuccess,
  loadYearlyLeaveError,
  loadDailyPercentageList,
  loadDailyPercentageListSuccess,
  loadDailyPercentageListError,
  loadWeeklyPercentageList,
  loadWeeklyPercentageListSuccess,
  loadWeeklyPercentageListError,
  loadMonthlyPercentageList,
  loadMonthlyPercentageListSuccess,
  loadMonthlyPercentageListError,
  loadEmployeeStatusList,
  loadEmployeeStatusListSuccess,
  loadEmployeeStatusListError,
  loadDepartment,
  loadDepartmentSuccess,
  loadDepartmentError,
  loadAttendanceTodayOverview,
  loadAttendanceTodayOverviewSuccess,
  loadAttendanceTodayOverviewError,
  loadAttendanceThisWeekOverview,
  loadAttendanceThisWeekOverviewSuccess,
  loadAttendanceThisWeekOverviewError,
  loadAttendanceThisMonthOverview,
  loadAttendanceThisMonthOverviewSuccess,
  loadAttendanceThisMonthOverviewError,
  loadAttendanceOverview,
  loadAttendanceOverviewSuccess,
  loadAttendanceOverviewError,
  loadLate,
  loadLateError,
  loadLateSuccess,
  loadEmployeeType,
    loadEmployeeTypeSuccess,
    loadEmployeeTypeError
} from "./actions";

import {
  loadBirthdayListDetails,
  loadDashboardAttandanceAPI,
  loadDashboardCheckinOutAPI,
  loadHolidayListDetails,
  loadYearlyLeaveAPI,
  loadDailyPercentangeAPI,
  loadWeeklyPercentangeAPI,
  loadMonthlyPercentangeAPI,
  loadEmployeeStatusAPI,
  loadDepartmentAPI,
  loadAttendanceTodayOverviewAPI,
  loadAttendanceThisWeekOverviewAPI,
  loadAttendanceThisMonthOverviewAPI,
  loadAttendanceOverviewAPI,
  loadLateAPI,
  loadEmployeeTypeAPI
} from "./remotes";

function* loadBirthdayListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_BIRTHDAY_LIST),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadBirthdayList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadBirthdayListDetails, searchFilter);
        if (result) {
          yield put(loadBirthdayListSuccess(result.wishes));
        }
      } catch (error) {
        yield put(
          loadBirthdayListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardAttendanceSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DASHBOARD_ATTENDANCE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadDashboardAttendance(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDashboardAttandanceAPI, searchFilter);
        if (result) {
          yield put(loadDashboardAttendanceSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadDashboardAttendanceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardCheckinOutSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DASHBOARD_CHECKINOUT),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadDashboardCheckinOut(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDashboardCheckinOutAPI, searchFilter);
        if (result) {
          yield put(loadDashboardCheckinOutSuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadDashboardCheckinOutError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadHolidayListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_HOLIDAY_LIST),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadHolidayList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadHolidayListDetails, searchFilter);
        if (result) {
          yield put(loadHolidayListSuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadHolidayListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadYearlyLeaveSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_YEARLY_LEAVE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadYearlyLeave(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadYearlyLeaveAPI, searchFilter);
        if (result) {
          yield put(loadYearlyLeaveSuccess(result));
        }
      } catch (error) {
        yield put(
          loadYearlyLeaveError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDailyPercentageSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DAILY_PERCENTAGE_LIST),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadDailyPercentageList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDailyPercentangeAPI, searchFilter);
        if (result) {
          yield put(loadDailyPercentageListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDailyPercentageListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadWeeklyPercentageSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_WEEKLY_PERCENTAGE_LIST),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadWeeklyPercentageList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadWeeklyPercentangeAPI, searchFilter);
        if (result) {
          yield put(loadWeeklyPercentageListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadWeeklyPercentageListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadMonthlyPercentageSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_MONTHLY_PERCENTAGE_LIST),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadMonthlyPercentageList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadMonthlyPercentangeAPI, searchFilter);
        if (result) {
          yield put(loadMonthlyPercentageListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadMonthlyPercentageListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadEmployeeStatusSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_STATUS),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadEmployeeStatusList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeStatusAPI, searchFilter);
        if (result) {
          yield put(loadEmployeeStatusListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadEmployeeStatusListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDepartmentSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_DEPARTMENT),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadDepartment(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDepartmentAPI, searchFilter);
        if (result) {
          yield put(loadDepartmentSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDepartmentError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadAttendanceTodayOverviewSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ATTENDANCE_OVERVIEW_TODAY),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadAttendanceTodayOverview(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAttendanceTodayOverviewAPI, searchFilter);
        if (result) {
          yield put(loadAttendanceTodayOverviewSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAttendanceTodayOverviewError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadAttendanceThisWeekOverviewSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ATTENDANCE_OVERVIEW_THISWEEK),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadAttendanceThisWeekOverview(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadAttendanceThisWeekOverviewAPI,
          searchFilter
        );
        if (result) {
          yield put(loadAttendanceThisWeekOverviewSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAttendanceThisWeekOverviewError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadAttendanceThisMonthOverviewSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ATTENDANCE_OVERVIEW_THISMONTH),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadAttendanceThisMonthOverview(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadAttendanceThisMonthOverviewAPI,
          searchFilter
        );
        if (result) {
          yield put(loadAttendanceThisMonthOverviewSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAttendanceThisMonthOverviewError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
//loadAttendanceOverview

function* loadAttendanceOverviewSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ATTENDANCE_OVERVIEW),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadAttendanceOverview(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadAttendanceOverviewAPI,
          searchFilter
        );
        if (result) {
          yield put(loadAttendanceOverviewSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadAttendanceOverviewError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

//load late  loadLate

function* loadLateSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_LATE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadLate(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadLateAPI,
          searchFilter
        );
        if (result) {
          yield put(loadLateSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadLateError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadEmployeeTypeSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE_TYPE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadEmployeeType(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadEmployeeTypeAPI,
          searchFilter
        );

        console.log(result,"result")
        if (result) {
          yield put(loadEmployeeTypeSuccess(result));
        }
      } catch (error) {
        yield put(
          loadEmployeeTypeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadBirthdayListSaga(),
    loadDashboardAttendanceSaga(),
    loadDashboardCheckinOutSaga(),
    loadHolidayListSaga(),
    loadYearlyLeaveSaga(),
    loadDailyPercentageSaga(),
    loadWeeklyPercentageSaga(),
    loadMonthlyPercentageSaga(),
    loadEmployeeStatusSaga(),
    loadDepartmentSaga(),
    loadAttendanceTodayOverviewSaga(),
    loadAttendanceThisWeekOverviewSaga(),
    loadAttendanceThisMonthOverviewSaga(),
    loadAttendanceOverviewSaga(),
    loadLateSaga(),
    loadEmployeeTypeSaga()
  ]);
}
